import { Button } from "@super-resume-new/ui/components/button";
import { Link } from "@tanstack/react-router";
import { ArrowRight, BookOpen, HelpCircle } from "lucide-react";

export function FaqCallout() {
  return (
    <section className="mx-auto mt-14 w-full">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-6 rounded-xl border border-border bg-card p-4 shadow-sm">
        <div className="flex items-center gap-4">
          <div className="flex size-16 items-center justify-center rounded-xl bg-brand/10 text-brand-foreground shrink-0 mt-0.5">
            <HelpCircle className="size-8" />
          </div>
          <div>
            <div className="flex items-center">
              <h3 className="text-sm font-semibold text-foreground">
                Frequently Asked Questions & Help Guide
              </h3>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-2xl">
              Learn how our AI engine restructures bullets under a strict budget, passes applicant
              tracking systems (ATS), handles career honesty with defend cards, and maximizes
              keyword match rates.
            </p>
          </div>
        </div>
        <Link to="/faq">
          <Button
            variant="outline"
            className="group whitespace-nowrap bg-background hover:bg-accent text-sm font-semibold shrink-0 cursor-pointer"
          >
            <BookOpen className="size-4 text-muted-foreground mr-1.5" />
            Explore All FAQs
            <ArrowRight className="size-4 ml-1.5 transition-transform group-hover:translate-x-0.5" />
          </Button>
        </Link>
      </div>
    </section>
  );
}

export const Faq = FaqCallout;
